import { authHandler } from './auth.js';
import { billingInvoicesHandler } from './billing-invoices.js';
import { billingInvoicesListHandler } from './billing-invoices-list.js';
import { brandHandler } from './brand.js';
import { brandStatusHandler } from './brand-status.js';
import { disputesHandler } from './disputes.js';
import { feedbackHandler } from './feedback.js';
import { formSubmissionHandler } from './form-submission.js';
import { gbpHandler } from './gbp.js';
import { homeHandler } from './home.js';
import { inboxHandler } from './inbox.js';
import { launchHandler } from './launch.js';
import { locationIntegrationsHandler } from './location-integrations.js';
import { marketingAutomationHandler } from './marketing-automation.js';
import { marketplaceOnboardingHandler } from './marketplace-onboarding.js';
import { menuItemPhotoHandler } from './menu-item-photo.js';
import { orderHandler } from './order.js';
import { paymentsAccountHandler } from './payments-account.js';
import { printShopHandler } from './print-shop.js';
import { salesQuoteHandler } from './sales-quote.js';
import { staffMembersHandler } from './staff-members.js';
// Re-export each module so consumers load its CustomerDeeplinkParamsByKey
// augmentation (a bare side-effect import is elided from the emitted .d.ts).
export * from './auth.js';
export * from './billing-invoices.js';
export * from './billing-invoices-list.js';
export * from './brand.js';
export * from './brand-status.js';
export * from './disputes.js';
export * from './feedback.js';
export * from './form-submission.js';
export * from './gbp.js';
export * from './home.js';
export * from './inbox.js';
export * from './launch.js';
export * from './location-integrations.js';
export * from './marketing-automation.js';
export * from './marketplace-onboarding.js';
export * from './menu-item-photo.js';
export * from './order.js';
export * from './payments-account.js';
export * from './print-shop.js';
export * from './sales-quote.js';
export * from './staff-members.js';
// Every registered customer deeplink. Typed as CustomerDeeplinkHandlers so adding
// a key to CustomerDeeplinkParamsByKey without a handler here is a compile error.
export const CUSTOMER_HANDLERS = {
    inbox: inboxHandler,
    home: homeHandler,
    order: orderHandler,
    gbp: gbpHandler,
    'menu-item-photo': menuItemPhotoHandler,
    'brand-status': brandStatusHandler,
    'billing-invoices': billingInvoicesHandler,
    'billing-invoices-list': billingInvoicesListHandler,
    'payments-account': paymentsAccountHandler,
    feedback: feedbackHandler,
    'form-submission': formSubmissionHandler,
    'marketing-automation': marketingAutomationHandler,
    launch: launchHandler,
    'sales-quote': salesQuoteHandler,
    'marketplace-onboarding': marketplaceOnboardingHandler,
    auth: authHandler,
    brand: brandHandler,
    disputes: disputesHandler,
    'location-integrations': locationIntegrationsHandler,
    'print-shop': printShopHandler,
    'staff-members': staffMembersHandler,
};
//# sourceMappingURL=index.js.map